import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
var ItalicIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5453 3.11889C13.5453 2.50109 14.0526 2.00026 14.6784 2.00026H43.8669C44.4927 2.00026 45 2.50109 45 3.11889C45 3.7367 44.4927 4.23753 43.8669 4.23753H14.6784C14.0526 4.23753 13.5453 3.7367 13.5453 3.11889Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 44.8811C3 44.2633 3.5073 43.7625 4.13309 43.7625H33.3216C33.9474 43.7625 34.4547 44.2633 34.4547 44.8811C34.4547 45.4989 33.9474 45.9997 33.3216 45.9997H4.13309C3.5073 45.9997 3 45.4989 3 44.8811Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5467 2.03348C30.1539 2.18292 30.5235 2.79002 30.3721 3.38947L19.8268 45.1517C19.6754 45.7511 19.0605 46.116 18.4533 45.9665C17.8461 45.8171 17.4765 45.21 17.6279 44.6105L28.1732 2.84832C28.3246 2.24886 28.9395 1.88405 29.5467 2.03348Z"
  }));
});
ItalicIcon.displayName = 'ItalicIcon';
ItalicIcon.defaultProps = {
  'aria-label': 'Italic'
};
export default ItalicIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/ItalicIcon/index.js
// module id = 1874
// module chunks = 12